<!--
  功能：自然语言创建页面
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：2024-06-06 10:09:45
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div
    class="zryz-bg index-info"
    :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'"
  >
    <!-- 头部信息  -->
    <div class="info-header">
      <navigation :text="'创建自定义因子'" :searchShow="true"></navigation>
    </div>
    <!-- 内容部分 -->
    <div class="info-content">
      <!--  tab 切换    -->
      <div class="content-tab">
        <span
          class="tab-text"
          :class="tabSelect == 1 ? 'tab-text-select' : ''"
          @click="tabSelectClick(1)"
          >输入自然语言</span
        >
        <span
          class="tab-text"
          :class="tabSelect == 2 ? 'tab-text-select' : ''"
          @click="tabSelectClick(2)"
          >使用慧搜收藏问句</span
        >
      </div>
      <!-- 展示内容 -->
      <!-- 输入自然语言内容 -->
      <div class="statement-content" v-show="tabSelect == 1">
        <!-- 输入框部分 -->
        <div class="statement-text">
          <van-field
            class="text-field"
            v-model="zryyText"
            rows="10"
            autosize
            type="textarea"
            maxlength="200"
            placeholder="在此输入自然语言"
            show-word-limit
          />
        </div>
        <!-- 按钮部分 -->
        <div class="input-text">
          <van-button
            plain
            type="primary"
            color="#286DF7"
            class="input-text-btn1"
            :loading="butLoading"
            loading-text="股池查询中..."
            @click="verifyTextFun()"
            >查看当日股池</van-button
          >
          <van-button
            type="primary"
            color="#286DF7"
            class="input-text-btn2"
            :loading="analyzeLoading"
            loading-text="语句解析中..."
            @click="analyzeTextFun()"
            >解析自然语言</van-button
          >
        </div>
      </div>
      <!-- 使用收藏问句内容 -->
      <div class="collect-content" v-show="tabSelect == 2">
        <div class="content-info" v-show="collectText.length > 0">
          <van-row class="content-list">
            <van-col span="4" class="content-item">选择</van-col>
            <van-col span="4" class="content-item">序号</van-col>
            <van-col span="16" class="content-item">收藏问句</van-col>
          </van-row>
          <!-- 语句选择 -->
          <van-checkbox-group v-model="resultSelect" :max="1">
            <van-row
              class="content-list"
              v-for="(item, index) in collectText"
              :key="index"
              @click="clickSelect(index)"
            >
              <van-col span="4" class="content-item">
                <van-checkbox :name="index"></van-checkbox>
              </van-col>
              <van-col span="4" class="content-item blackText">{{ index + 1 }}</van-col>
              <van-col span="16" class="content-item blackText">{{ item.issue }}</van-col>
            </van-row>
          </van-checkbox-group>
        </div>
        <van-empty
          description="您还没有在慧搜收藏过问句哦，去慧搜搜索你感兴趣的语句吧~"
          v-show="!collectText.length"
          :image="require('@/assets/image/notData.png')"
        />
      </div>
    </div>

    <!-- 收藏语句的弹窗 -->
    <div class="collect-but" v-show="tabSelect == 2">
      <div class="collect-but-stock">
        <van-button
          class="collect-but-info collect-stock-but"
          @click="verifyTextFun()"
          :disabled="resultSelect.length == 0"
          :loading="butLoading"
          loading-text="股池查询中..."
          >查看当日股池</van-button
        >
      </div>
      <div class="collect-but-sub">
        <van-button
          class="collect-but-info collect-sub-but"
          @click="analyzeTextFun()"
          :disabled="resultSelect.length == 0"
          :loading="analyzeLoading"
          loading-text="语句解析中..."
          >解析自然语言</van-button
        >
      </div>
    </div>
    <!-- 底部弹窗 -->
    <van-popup
      class="van-popup-info"
      v-model="stockShow"
      round
      closeable
      position="bottom"
      :style="{ height: '80%' }"
      :close-icon="
        $route.query.themeStyleVs == 2
          ? require('@/assets/image/zryy/closeWhite.png')
          : require('@/assets/image/zryy/close2x.png')
      "
    >
      <div class="popup-info">
        <!-- 标题 -->
        <div class="popup-header">当日股池({{ObjCount}})</div>
        <!-- 股票列表 -->
        <div class="popup-stock">
          <van-list
            v-model="loadingStocks"
            :finished="finishedStocks"
            finished-text="没有更多了"
            @load="onLoadStocks"
          >
            <table width="100%" cellspacing="0" cellpadding="0" v-if="stockList.length > 0">
              <tr class="stock-title">
                <th>股票名称</th>
                <th>最新</th>
                <th>涨幅%</th>
                <th>涨跌</th>
              </tr>

              <tr v-for="(item, index) in stockList" :key="index" @click="gogufs(item.Obj)">
                <td>
                  <p>{{ item.ZhongWenJianCheng }}</p>
                  <p>{{ item.JiaoYiDaiMa }}</p>
                </td>
                <td>{{ toFixedNum(item.ZuiXinJia, 2, '') }}</td>
                <td :class="[judgeColor(item.ZhangFu)]">{{ toFixedNum(item.ZhangFu, 2, '%') }}</td>
                <td>{{ toFixedNum(item.ZhangDie, 2, '') }}</td>
              </tr>
            </table>
          </van-list>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import navigation from '@/components/navigation.vue';
import { toFixedNum, judgeColor, formtTime } from '@/utils/format';
import { getLanguageForStock, issueList } from '@/api/factor.js';
import { getObjSort } from '@/api/index.js';
import mixin from '@/mixins/index.js';
export default {
  name: '',
  mixins: [mixin],
  components: { navigation },
  data() {
    return {
      //   获取 token
      //   获取主题
      //   获取版本号

      // tab切换背景
      tabSelect: 1,
      // message 自然语言输入的内容
      zryyText: '',
      // 股票列表弹窗
      stockShow: false,
      // 股票列表
      stockList: [],
      // 股票翻页加载
      loadingStocks: false,
      finishedStocks: false,
      // 排序
      xhfield: 'ZhangFu',
      xhdesc: true,
      // 股池条件
      ObjCount: 0,
      start: 1,
      limit: 20,
      // 查看股池的按钮 loading
      butLoading: false,
      // 解析因子的按钮 loading
      analyzeLoading: false,
      // 语句解析的按钮 loading
      statementLoading: false,
      // 解析完的数据
      analyzeData: {},
      // 解析的因子 ID
      FactorIDs: '',
      // 解析出的可回测因子
      backtestYz: [],
      // 解析出的不可回测因子
      notBacktestYz: [],
      // 收藏的语句
      collectText: [],
      // 选中
      resultSelect: [],
      // 收藏语句条件
      hsPage: 1,
      hsTotal: 0,
      totalpage: 0
    };
  },
  filters: {},
  // 侦听器
  watch: {},
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {},
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted: function () {
    this.getMyCollect();
  },
  // 组件方法
  methods: {
    toFixedNum,
    judgeColor,
    formtTime,
    // 点击 tab 进行切换
    tabSelectClick: function (index) {
      if (this.tabSelect == index) {
        return false;
      }
      // 弹窗
      this.$dialog
        .confirm({
          message: '切换输入自然语言/使用慧搜收藏问句后,当前输入的内容将会被清空,是否确定切换?',
          confirmButtonText: '确认',
          confirmButtonColor: '#286df7',
          cancelButtonText: '取消',
          cancelButtonColor: '#949da8'
        })
        .then(() => {
          // on confirm
          this.tabSelect = index;
          // 初始化条件单
          this.initializeConditions();
        })
        .catch(() => {
          // on cancel
        });
    },
    // 初始化条简单
    initializeConditions: function () {
      // 自然语言输入框置空
      this.zryyText = '';
      // 搜藏语句选中置空
      this.resultSelect = [];
      // 查询条件初始化
      this.ObjCount = 0;
      this.start = 1;
      this.xhfield = 'zhangfu';
      this.xhdesc = true;
      // 解析因子初始化
      this.analyzeData = {};
      this.FactorIDs = '';
      this.backtestYz = [];
      this.notBacktestYz = [];
      // 股池初始化
      this.stockList = [];
    },

    // 查看自然语言校验
    verifyTextFun: function () {
      if (this.zryyText == '') {
        this.$dialog.alert({
          message: '自然语言为空',
          confirmButtonColor: '#286df7'
        });
      } else {
        this.butLoading = true;
        this.handleViewStocks('stock');
      }
    },

    // 解析自然语言
    analyzeTextFun: function () {
      if (this.zryyText == '') {
        this.$dialog.alert({
          message: '自然语言为空',
          confirmButtonColor: '#286df7'
        });
      } else {
        this.analyzeLoading = true;
        this.handleViewStocks('analyze');
      }
    },
    // 解析语句(股票)
    handleViewStocks: function (text) {
      if (text == 'stock' || text == 'analyze') {
        this.start = 1;
        this.ObjCount = 0;
        this.stockList = [];
        this.finishedStocks = false;
      }

      let params = {
        text: this.zryyText,
        field: 'zhangfu',
        desc: 'true',
        start: this.start,
        count: this.limit
      };
      getLanguageForStock(params)
        .then((result) => {
          this.butLoading = false;
          this.analyzeLoading = false;
          this.statementLoading = false;
          // 获取成功
          if (result.err == 200) {
            this.analyzeData = result.data;
            this.notBacktestYz = result.data.notBacktestYz;
            this.backtestYz = result.data.backtestYz;
            this.FactorIDs = result.data.FactorIDs;
            // 股票列表
            this.stockList = result.data.stocks;
            // 总条数
            this.ObjCount =
              result.data.ObjCount && result.data.ObjCount == '' ? 0 : result.data.ObjCount;

            // 数据全部加载完成
            if (result.data.stocks.length < this.limit) {
              this.finishedStocks = true;
            }

            // 如果是解析,就判断一下是否有可回测的因子,如果没有就挡住
            if (text == 'analyze') {
              if (result.data.backtestYz.length == 0) {
                this.$dialog.alert({
                  message: '当前自然语言未匹配到可回测的因子，换个语句试试吧',
                  confirmButtonColor: '#286df7'
                });
              } else {
                // 存储vuex, 跳转下个页面
                let storeData = {
                  zryyText: this.zryyText,
                  tabSelect: this.tabSelect,
                  resultSelect: this.resultSelect,
                  analyzeData: this.analyzeData
                };
                this.$store.commit('setZryyData', storeData);
                // 跳转
                window.location.href = '/zryypreview?DZHSPECIAL=4194560&sourceType=true';
              }
            }
            // 如果是股池,判断一下股票是否为空,如果为空就挡住
            if (text == 'stock') {
              // 判断股池是否为空
              if (result.data.stocks.length == 0) {
                // 股池为空,换个语句
                this.$dialog.alert({
                  message: '当前自然语言未匹配到股票，换个语句试试吧',
                  confirmButtonColor: '#286df7'
                });
              } else {
                // 显示股池弹窗
                this.stockShow = true;
              }
            }
          } else {
            // 获取失败
            this.butLoading = false;
            this.analyzeLoading = false;
            this.statementLoading = false;
            // 提示语句解析失败,换个语句试试吧
            $this.$dialog.alert({
              message: '当前自然语言未匹配到股票，换个语句试试吧',
              confirmButtonColor: '#286df7'
            });
          }
          console.log('result', result);
        })
        .catch((err) => {
          // 获取失败
          this.butLoading = false;
          this.analyzeLoading = false;
          this.statementLoading = false;
          // 提示语句解析失败,换个语句试试吧
        });
    },
    // 选中收藏问句
    clickSelect: function (index) {
      if (this.resultSelect[0] == index) {
        return false;
      }
      this.resultSelect = [index];
      // 赋值语句
      this.zryyText = this.collectText[index].issue;
    },
    // 获取收藏语句
    getMyCollect: function () {
      let params = {
        page: this.hsPage
      };
      issueList(params)
        .then((result) => {
          if (result.err == 0) {
            this.collectText = result.data.list;
            this.hsTotal = result.data.total;
            this.totalpage = result.data.totalpage;
          }
        })
        .catch((err) => {});
    },
    // 翻页加载过票数据
    onLoadStocks: function () {
      // 异步加载股票数据
      // console.log('this.FactorIDs', this.FactorIDs);
      // console.log('this.start', this.start);
      // console.log('this.limit', this.limit);
      this.start = this.start + this.limit;
      // 创建条件
      let params = {
        factorid: this.FactorIDs,
        field: this.xhfield,
        desc: this.xhdesc,
        start: this.start,
        count: this.limit
      };
      getObjSort(params)
        .then((res) => {
          if (res.err === 200 && res.data.list.length > 0) {
            this.ObjCount = res.data.ObjCount;
            this.stockList = [...this.stockList, ...res.data.list];
            // 加载状态结束
            this.loadingStocks = false;
            // 数据全部加载完成
            if (res.data.list.length < this.limit) {
              this.finishedStocks = true;
            }
          } else {
            this.loadingStocks = false;
            this.finishedStocks = true;
          }
        })
        .catch((err) => {
          this.loadingStocks = false;
          this.finishedStocks = true;
        });
      console.log('params', params);
    }
  }
};
</script>

<style scoped lang="less">
.zryz-bg {
  height: 100vh;
  overflow: hidden;
  background-color: #e9eff8;
  background-image: url('../../assets/image/zryy/zryy-bg.png');
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 100%; /* 背景图宽度自适应 */
  background-attachment: fixed;
  position: relative;
  //  头部
  .info-header {
    margin-top: 44px;
  }
  //  内容部分
  .info-content {
    padding: 0;
    // 切换
    .content-tab {
      height: 36px;
      margin: 8px 52px;
      background-color: #edf3fb;
      border-radius: 8px;

      .tab-text {
        display: inline-block;
        width: 50%;
        height: 36px;
        text-align: center;
        line-height: 36px;
        color: #4e5969;
        font-size: 14px;
        font-weight: 400;
        position: relative;
      }
      .tab-text-select {
        background: #fff;
        border-radius: 8px;
        color: #1d2129;
        font-weight: 500;
      }
    }
  }

  // 内容 - 语句部分
  .statement-content {
    padding: 9px 16px;
    // 输入部分
    .statement-text {
      // padding: 12px 16px;
      background-color: #fff;
      border-radius: 8px;
      .text-field {
        border-radius: 8px;
      }
    }
    // 点击按钮部分
    .input-text {
      margin-top: 16px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: space-between;
      align-items: center;
      .input-text-btn1 {
        width: 45%;
        border-radius: 6px;
        color: #286df7;
        font-size: 14px;
        font-weight: 500;
        background-color: rgba(255, 255, 255, 0);
      }
      .input-text-btn2 {
        width: 45%;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  // 内容 - 收藏部分
  .collect-content {
    width: 100%;
    height: 100vh;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 8px;
    padding: 16px;
    margin-top: 16px;
    .content-info {
      background: rgba(255, 255, 255, 0);
      border-radius: 0px;
      height: calc(100vh - 200px);
      overflow: hidden;
      overflow-y: auto;
      padding-bottom: 30px;
      .content-list {
        margin-bottom: 16px;
        .content-item {
          text-align: left;
          color: #949da8;
          font-size: 13px;
        }
        .blackText {
          color: #4e5969;
          font-size: 15px;
        }
      }
    }

    // .collect-but {
    //   position: relative;
    //   bottom: 30px;
    //   margin: 0 auto;
    //   display: block;
    //   width: 80%;
    //   background:#286df7;
    //   font-weight:500;
    //   color:#ffffff;
    //   font-size:16px;
    // }
    // .van-button--disabled {
    //   background-color: #a9c5fc !important;
    //   color:#ffffff !important;
    // }
  }

  // 搜藏语句的按钮

  .collect-but {
    height: 46px;
    width: 100%;
    position: absolute;
    bottom: 30px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    padding: 0 16px;
    .collect-but-info {
      border-radius: 6px;
    }

    .collect-but-stock {
      width: 45%;
      .collect-stock-but {
        width: 100%;
        border: 0.5px solid #286df7;
        background: #e5ecfb;
        color: #286df7;
        font-size: 14px;
        font-weight: 500;
      }
      .van-button--disabled {
        background: #eff4fd !important;
        color: #7ea7fa !important;
      }
    }

    .collect-but-sub {
      width: 45%;
      .collect-sub-but {
        width: 100%;
        background: #286df7;
        font-weight: 500;
        color: #ffffff;
        font-size: 14px;
      }
      .van-button--disabled {
        background: #a9c5fc !important;
        color: #fff !important;
      }
    }
  }

  // 股池弹窗部分
  .popup-info {
    padding: 14px 16px;
    height: 100%;
    // border: 1px solid red;
    .popup-header {
      // border: 1px solid red;
      font-weight: 600;
      color: #1d2129;
      font-size: 18px;
    }
    .popup-stock {
      // border: 1px solid red;
      height: calc(100% - 32px);
      overflow: hidden;
      overflow-y: auto;
      .stock-title {
        position: sticky;
        top: 0px;
        background: #fff;
      }
      .stock-listInfo {
        // display: contents;
      }
      table {
        th {
          font-size: 12px;
          color: #999999;
          font-weight: 400;
          padding: 4px 0;
          width: 25%;
          padding-right: 15px;
          text-align: right;
          box-sizing: border-box;
          font-family: 'dzh';
          &:first-child {
            // padding-left: 15px;
            box-sizing: border-box;
            text-align: left;
            width: 25%;
          }
          // &:last-child {
          //   padding-right: 15px;
          //   box-sizing: border-box;
          //   text-align: right;
          //   width: 25%;
          // }
        }
        td {
          height: 57px;
          text-align: center;
          font-size: 17px;
          color: #555555;
          width: 25%;
          padding-right: 15px;
          text-align: right;
          box-sizing: border-box;
          font-weight: 500;
          font-family: 'dzh';
          &:first-child {
            // padding-left: 15px;
            width: 25%;
            p {
              text-align: left;
              &:first-child {
                color: #555555;
                font-weight: 600;
                font-size: 14px;
                line-height: 20px;
              }
              &:last-child {
                color: #999999;
                font-size: 12px;
                line-height: 17px;
              }
            }
          }
        }
      }
    }
  }
}

.black_theme {
  background-color: #0b172c;
  background-image: url('../../assets/image/zryy/zryy-bg-black.png');
  // 导航
  .navget_main {
    color: #ffffff;
  }
  .info-content {
    .content-tab {
      background: rgba(255, 255, 255, 0.1);
      border: 0.5px solid rgba(255, 255, 255, 0.3);
      color: #c9cbdc;
      .tab-text {
        color: #c9cbdc;
      }
      .tab-text-select {
        background: rgba(255, 255, 255, 0.15);
        color: #e4e9fe;
      }
    }
  }

  // 语句部分
  .statement-content {
    .statement-text {
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.1);
      .text-field {
        background: rgba(255, 255, 255, 0);
        ::v-deep {
          .van-field__control {
            color: #fff;
          }
        }
      }
    }
  }
  // 搜藏语句部分
  .collect-content {
    background: rgba(255, 255, 255, 0.1);
    .content-info {
      .content-list {
        .content-item {
          color: #aab9d1;
        }
        .blackText {
          color: #e4e9fe;
        }
      }
    }
  }

  // 搜藏语句按钮
  .collect-but {
    .collect-but-stock {
      .collect-stock-but {
        background: #283241;
        // background:rgba(59, 133, 254, 0.1);
        border: 0.5px solid;
        border-color: #3b85fe;
        color: #3b85fe;
      }
      .van-button--disabled {
        background: #283241 !important;
        color: #3362ae !important;
        border: 0.5px solid #3b85fe !important;
      }
    }
    .collect-but-sub {
      width: 45%;
      .collect-sub-but {
        width: 100%;
        background: #3b85fe;
        border: 0px;
        font-weight: 500;
        color: #ffffff;
        font-size: 14px;
      }
      .van-button--disabled {
        background: #2f5085 !important;
        color: #7d8186 !important;
        border: 0px !important;
      }
    }
  }

  // 弹窗部分
  .van-popup-info {
    background: #272935;
    .popup-header {
      color: #e4e9fe;
    }
    .popup-stock {
      .stock-title {
        background: #272935;
      }
      table {
        th {
          color: #aab9d1;
        }
        td {
          color: #c9cbdc;
          &:first-child {
            p {
              &:first-child {
                color: #c9cbdc;
              }
              &:last-child {
                color: #aab9d1;
              }
            }
          }
        }
      }
    }
  }
}
</style>
